export function DiscoveryChannels() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            The 4 Discovery Channels
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Modern customers find businesses through four critical channels. Your website must be optimized for all of them.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {[
            {
              icon: 'ri-google-fill',
              title: 'Google Search',
              desc: 'Traditional search engine results where most customers start their journey',
              color: 'from-blue-500 to-blue-600'
            },
            {
              icon: 'ri-robot-2-line',
              title: 'AI Answers',
              desc: 'ChatGPT, Perplexity, and other AI engines that provide direct answers',
              color: 'from-purple-500 to-purple-600'
            },
            {
              icon: 'ri-mic-line',
              title: 'Voice Assistants',
              desc: 'Siri, Alexa, Google Assistant answering spoken queries',
              color: 'from-teal-500 to-cyan-500'
            },
            {
              icon: 'ri-map-pin-line',
              title: 'Maps Search',
              desc: 'Google Maps and local search results for nearby businesses',
              color: 'from-red-500 to-orange-500'
            }
          ].map((channel, index) => (
            <div key={index} className="group">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-teal-500 transition-all h-full hover:bg-white/10">
                <div className={`w-16 h-16 bg-gradient-to-br ${channel.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${channel.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{channel.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{channel.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-500/20 to-cyan-500/20 backdrop-blur-sm rounded-2xl p-8 border border-teal-500/30">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-white text-4xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold mb-2">Digital Age Websites Are Optimized for All Four</h3>
              <p className="text-lg text-gray-300">
                Most businesses are only visible in one channel—or none at all. We ensure you're discoverable everywhere your customers are searching.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}